<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>{{ $route.name == "news-add" ? "Add" : "Edit" }} News</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(documentSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="news_category"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group form-select single-multiselect select-option-custom"
                      :class="{
                        errors: errors.length && !document.news_category,
                        success: document.news_category,
                      }"
                    >
                      <span class="float-label">
                        <label for="news_category" class="control-label">
                          News Category*
                        </label>
                        <multiselect
                          placeholder=""
                          v-model="document.news_category"
                          :show-labels="false"
                          :options="['Sports']"
                        ></multiselect>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !document.news_category"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="document.news_category"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="news_heading"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !document.news_heading,
                        success: document.news_heading,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="document.news_heading"
                          class="form-control"
                          placeholder="News Heading"
                        />
                        <label for="cms" class="control-label">
                          News Heading*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !document.news_heading"
                        ></i>
                        <i class="fa fa-check" v-if="document.news_heading"></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <div class="form-group">
                    <span class="float-label">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="inputGroupFile01"
                          @change="upload"
                        />
                        <label class="custom-file-label" for="inputGroupFile01">
                          Upload File
                        </label>
                      </div>
                      <div class="ml-2">
                        {{ document.file.name }}
                      </div>
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="content" class="control-label">Content</label>
                    <span class="float-label">
                      <vue-editor v-model="document.content"></vue-editor>
                    </span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center w-25"
                  >
                    <label class="mb-0" for="customSwitchstatus">Status</label>
                    <div class="custom-switch success-error-bg">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        id="customSwitchstatus"
                        v-model="document.status"
                      />
                      <label
                        class="custom-switch-label pr-4 pl-5"
                        for="customSwitchstatus"
                      >
                        <span class="custom-switch-text1">Active</span>
                        <span class="custom-switch-text2">InActive</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
const { VueEditor } = require("vue2-editor");
export default {
  name: "AddOrEditNewsComponent",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    ValidationObserver,
    ValidationProvider,
    VueEditor,
  },
  data() {
    return {
      document: {
        news_heading: "",
        news_category: "Sports",
        file: "",
        content: "",
        status: true,
      },
    };
  },
  methods: {
    documentSubmit() {
      console.log(this.document);
    },
    upload(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.document.file = file;
      }
    },
  },
  mounted() {
    if (this.$route.name == "news-edit") {
      this.document = {
        news_heading: "Sports",
        news_category: "Sports",
        file: "myfile.txt",
        content: "<p>COMING SOON</p>",
        status: true,
      };
    }
  },
};
</script>
